export default "__VITE_ASSET__CfGdvCc6__"